module.exports = __webpack_public_path__ + "img/coupon_bg1.8c3a8e49.png";